import React, { useEffect } from 'react'
import CompanyProfile from './CompanyProfile';

const BranchCompanyProfile = () => {
  return (
    <CompanyProfile />
  )
}

export default BranchCompanyProfile